import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {countries} from '~/lib/countries';
import {Intent} from '~/lib/intent';
import {ID} from '~/lib/model';

interface ISelectCountryProps extends Omit<ISelectProps<ID>, 'items'> {
    short?: boolean;
}

export const SelectCountry = ({
    disabled,
    short,
    ...props
}: ISelectCountryProps) => <SelectInput {...props} disabled={disabled}
    items={countries.map(country => ({
        label: short ? country.code2 : country.name,
        value: short ? country.code2 : country.code3
    }))}/>;

export const SelectCountryField = (props: IFieldProps<ISelectCountryProps>) => <FormField {...props}>
    <SelectCountry {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
